import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 31px;
  position: relative;
  height: 20px;
  &:before {
    content: " ";
    width: 18px;
    height: 18px;
    position: absolute;
    top: 0;
    right: 0;
    border: 1px solid ${Variables.colors.complementary_400};
    ${props => {
      if (props.select) {
        return `
				border-color: ${Variables.colors.primary_vivid};
			`;
      } else {
        return `
					border-color: ${Variables.colors.complementary_400};
				`;
      }
    }};
    border-radius: 50%;
  }
  &:after {
    position: absolute;
    top: 6px;
    right: 6px;
    ${props => {
      if (props.select) {
        return `
					background-color: ${Variables.colors.primary_vivid};
				`;
      } else {
        return `
					background-color: transparent;
				`;
      }
    }};
    width: 8px;
    height: 8px;
    border-radius: 50%;
    content: " ";
  }
`;
